import { render, staticRenderFns } from "./filters.html?vue&type=template&id=0928940d&"
import script from "./felters.js?vue&type=script&lang=js&"
export * from "./felters.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports